// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const SaveRecipeButton = registerClientReference(
    function() { throw new Error("Attempted to call SaveRecipeButton() from the server but SaveRecipeButton is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/recipes/save-recipe-button.tsx",
    "SaveRecipeButton",
);
